var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRewind = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 19390",
  transform: "translate(-182 -731)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  "data-name": "Ellipse 1560",
  transform: "translate(182 731)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 15459"
}, /*#__PURE__*/React.createElement("path", {
  d: "M186 759v-24h24v24Z",
  "data-name": "Path 5191",
  opacity: 0.01
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 15202"
}, /*#__PURE__*/React.createElement("path", {
  d: "M193.13 753.31h8a5 5 0 0 0 0-10h-11",
  "data-name": "Path 5192"
}), /*#__PURE__*/React.createElement("path", {
  d: "m192.43 745.81-2.56-2.56 2.56-2.56",
  "data-name": "Path 5193"
}))))));
export { SvgRewind as ReactComponent };
export default __webpack_public_path__ + "static/media/rewind.cf2e3a6a00197a222a7c8cf4aa0169f6.svg";